<main class="login-shell">
  <section class="login-card" aria-label="Ingreso al backoffice">
    <header class="brand">
      <div class="brand__mark">K</div>
      <div>
        <div class="brand__name">Kozaca</div>
        <div class="brand__caption">Portal Financiadores · Backoffice</div>
      </div>
    </header>

    <div class="intro">
      <h1>Ingresá a tu cuenta</h1>
      <p>Panel de administración del servicio de historia clínica interoperable.</p>
    </div>

    <form class="login-form" [formGroup]="form" (ngSubmit)="onSubmit()">
      <label class="field">
        <span>Correo</span>
        <mat-form-field appearance="outline" class="field__control">
          <input matInput type="email" placeholder="nombre@grupoorono.com.ar" formControlName="email" />
        </mat-form-field>
      </label>

      <label class="field">
        <span>Contraseña</span>
        <mat-form-field appearance="outline" class="field__control">
          <input
            matInput
            [type]="hidePassword ? 'password' : 'text'"
            placeholder="••••••••"
            formControlName="password"
          />
          <button
            mat-icon-button
            matSuffix
            type="button"
            (click)="hidePassword = !hidePassword"
            [attr.aria-label]="hidePassword ? 'Mostrar contraseña' : 'Ocultar contraseña'"
            [attr.aria-pressed]="!hidePassword"
          >
            <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
        </mat-form-field>
      </label>

      <div class="form-options">
        <label class="remember">
          <input type="checkbox" checked />
          <span>Recordarme</span>
        </label>
        <button type="button" class="link-button" (click)="gotoForgotPassword()">
          ¿Olvidaste tu contraseña?
        </button>
      </div>

      <button type="submit" [disabled]="form.invalid" class="submit-button">Ingresar</button>
    </form>

    <p class="restricted-copy">Acceso restringido a operadores autorizados de Grupo Oroño.</p>
  </section>
</main>
